import { useCallback } from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';
import { useAnalyticsEvents } from '@atlaskit/teams-app-internal-analytics/use-analytics-events';

import { AnalyticsEventActions, useAnalytics } from '../AnalyticsContext';
import { useDialog } from '../Dialog';

import FeedbackDialogLazy from './lazy';
import { type FeedbackTriggerProps } from './types';

// Id is gotten from https://jsd-widget.atlassian.com/api/embeddable/<EMBEDDABLE_KEY>/widget
export const WIDGET_EMBEDDABLE_KEY = 'customfield_11698';

export const useFeedbackDialog = (
	props: Omit<FeedbackTriggerProps, 'sourceNext'>,
): (() => void) => {
	const analytics = useAnalytics();
	const { fireEvent } = useAnalyticsEvents();
	const { openDialog } = useDialog();

	const { addFlag, extraData, source, appName, entrypoint } = props;

	const openFeedbackDialog = useCallback(() => {
		if (fg('ptc-enable-ptc-common-analytics-refactor')) {
			fireEvent(`ui.sendFeedback.clicked`, undefined);
		} else {
			analytics.pushUIEvent({
				source,
				action: AnalyticsEventActions.CLICKED,
				actionSubject: 'sendFeedback',
			});
		}
		openDialog(FeedbackDialogLazy, {
			appName,
			addFlag,
			extraData,
			entrypoint,
		});
	}, [addFlag, analytics, appName, extraData, openDialog, source, entrypoint, fireEvent]);

	return openFeedbackDialog;
};
